import { gql } from '@apollo/client';

export const fetchShipToPartiesForTransactionAccountPPC = gql`
  query fetchShipToPartiesForTransactionAccountPPC($id: ID!, $shipToPartyOptions: ShipToPartyOptions) {
    transactionAccount(id: $id) {
      id
      shipToParty(shipToPartyOptions: $shipToPartyOptions) {
        pageInfo {
          endCursor
          hasNextPage
        }
        nodes {
          name
          id
          addressLine1
          addressLine2
          city
          state
          country
          postcode
          taxId
          priceEligibility
          isActive
          taxIds {
            id
            label
            metadata {
              vatStatus
            }
            taxExempt
          }
          taxExempt
          taxLabels {
            region
            taxIdLabels {
              description
              displayName
              type
              metadata {
                type
                labels {
                  default
                  label
                  vatStatus
                }
              }
            }
          }
        }
      }
    }
  }
`;
